import { inject } from '@angular/core';
import { CanActivateFn, GuardResult } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';

import { selectBreakpointActive } from '@core/stores/breakpoint/breakpoint.selectors';

export const desktopOnlyCanActivateGuard =
  (createNonDesktopResult?: () => GuardResult): CanActivateFn =>
  () => {
    const store = inject(Store);
    // Built synchronously while still inside the guard's injection context, so the factory may use inject().
    const nonDesktopResult = createNonDesktopResult?.() ?? false;

    return store.select(selectBreakpointActive('lg')).pipe(
      take(1),
      map((isDesktop) => isDesktop || nonDesktopResult)
    );
  };
